import React from 'react';

import { ColorBubbleLetter } from '@lumapps/lumx-texts/components/ColorBubbleLetter';

import { Icon } from '@lumapps/lumx/react';
import { mdiChevronDown } from '@lumapps/lumx/icons';

/**
 * Display a custom header in the accordion box that display the list of channels.
 *
 * @param  {props} props The component properties.
 * @return {node}  The custom header.
 */
export const WidgetChannelListAccordionHeader = (props) => {
    let { channel } = props;

    return (
        <div className="channel-block__header">
            <div className="channel-block__thumbnail">
                <ColorBubbleLetter size="s" text={channel.name} />
            </div>

            <div className="channel-block__name">{channel.name}</div>

            <Icon icon={mdiChevronDown} className="channel-block__action custom-accordion-box__chevron" />
        </div>
    );
};
